import { QuizStateMachinePhase } from './quiz-state-machine-phase-state'
import { CancelToken } from '@/app/shared/utils'
import { reportNonFatalError } from '@/app/error-handling'

export interface QuizStateMachineCommonEvents {
  onCanceled: () => void
  onError: (err: unknown) => void
}

export abstract class QuizStateMachineAbstractState<TEvents extends QuizStateMachineCommonEvents>
{
  abstract name: QuizStateMachinePhase
  stateEvents: TEvents | null
  protected cancelToken: CancelToken = { cancel: false }

  abstract enter(): void
  abstract exit(): void
  abstract cancel(): void

  protected beginCancel() {
    this.cancelToken.cancel = true
  }

  protected endCancel() {
    this.triggerEvent(events => events.onCanceled())
  }

  triggerEvent(action: (events: TEvents) => void) {
    if (this.stateEvents) {
      action(this.stateEvents)
    } else {
      reportNonFatalError(`triggerEvent called after state exit at '${this.name}' state`,
                          action)
    }
  }
}
